module.exports = __webpack_public_path__ + "img/newborn-baby-with-parents.c7cee946.png";